const setCurrentUser = (state, payload) => {
  // eslint-disable-next-line global-require
  state.currentUser = {
    rememberSettings: {},
    ...payload,
  }
}

const setAudienceInfo = (state, payload) => {
  if (payload.audienceName) {
    state.audienceName = payload.audienceName
  }
  if (payload.audienceEmail) {
    state.audienceEmail = payload.audienceEmail
  }

  if (payload.audienceEmoji) {
    state.audienceEmoji = payload.audienceEmoji
  }
}

export default {
  setCurrentUser,
  setAudienceInfo,
}
